import styled from 'styled-components';

export const Container = styled.p(({ theme }) => ({
  marginInline: 0,
  marginBlock: '20rem',

  fontSize: theme.typography.size18,
  fontFamily: theme.typography.family.arial,
  color: theme.page.subtitle.text,
}));
